import { Toolbar } from '@mui/material'
import React from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, FilterSection, SelectField, ToolbarComponent } from '../../../../../components'
import { vanDriverHeadCells } from '../../../../../shared/data/headCells'
import { VanDriverForm } from './components/VanDriverForm'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { VanDriverDetail } from '../Routes/components/RouteDetail'
import { EditVanDriver } from './components/EditVanDriver'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { useSelector } from 'react-redux'
import { ImportIcon } from '../../../../../assets/icons'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'
import { toast } from 'react-toastify'

export const VanDriver = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)

  const [driverForm, setDriverForm] = React.useState(false)
  const [detail, setDetailOpen] = React.useState(false)
  const [schoolName, setSchoolName] = React.useState('')
  const [update, setUpdate] = React.useState(false)
  const [page, setPage] = React.useState(1)
  const [search, setSearch] = React.useState('')
  const { data: vanData, count,refetch } = useGlobal({
    userUrl: `${urls.VAN_DRIVER_GET}${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}&keyword=${search}`,
  })
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  // const { data: searchVan } = useGlobal({
  //   userUrl: `${urls.VAN_DRIVER_SEARCH}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : ''}&keyword=${search}`,
  // })
  const rowData = vanData || []
  const no_data_msg =
    customRole == 'Admin'
      ? 'Add driver to start over'
      : schoolName
        ? 'Add driver to start over'
        : 'Select school to see drivers'
  // const rowData = search ? searchVan : vanData
  const handleClose = () => {
    if (update) {
      setUpdate(false)
    } else {
      setDriverForm(false)
    }
  }

  const handleExport = () => {
    if (rowData && rowData.length > 0) {
      // Generate filename with school name
      let filename = 'Van_Drivers'

      if (schoolName) {
        const school = schoolList?.find((s) => s.school_id === schoolName)
        if (school) {
          filename += `_${school.school_name.replace(/\s+/g, '_')}`
        }
      } else if (customRole === 'Admin' && userSchoolName) {
        filename += `_${userSchoolName.replace(/\s+/g, '_')}`
      }

      // Add current date
      const date = new Date().toISOString().split('T')[0]
      filename += `_${date}`

      // Export the data
      downloadCSV(rowData, filename)
      // toast.success(`${rowData.length} van driver records exported`)
    } else {
      toast.error('No data to export')
    }
  }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Van Driver'} subtitle={'Van / Van Driver'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => {
                setSchoolName(selectedOption)
                setPage(1)
              }}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
        <ToolbarComponent
          classView
          handleOpen={() => setDriverForm(true)}
          search={search}
          setSearchItem={setSearch}
          setPage={setPage}
        >
          <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />
        </ToolbarComponent>
      </div>
      <DataTable
        // rowData={rowData}
        rowData={vanData}
        vanDriver
        headCells={vanDriverHeadCells}
        pageFee={page}
        pageCount={count}
        pages
        noDataMsg={no_data_msg}
        setPageFee={setPage}
        handleDetailOpen={() => setDetailOpen(true)}
        setUpdate={setUpdate}
        refetch={refetch}
      />
      {driverForm && (
        <VanDriverForm
          open={driverForm}
          handleClose={handleClose}
          customRole={customRole}
          userSchoolId={userSchoolId}
          update={update}
          title={'Add Van Driver'}
        />
      )}
      {detail && <VanDriverDetail open={detail} handleClose={() => setDetailOpen(false)} />}
      {update && <EditVanDriver open={update} handleClose={() => setUpdate(false)} />}
    </div>
  )
}
